import React, { useEffect } from "react";
import { Container } from "reactstrap";
import { apiError } from "../../slices/thunks";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showToast } from "../../Components/ToastNotification";
import CommonLoading from "../../Components/Common/CommonLoading";
import axios from "axios";
import { loginSuccess } from "../../slices/auth/login/reducer";
import { addPersistLoginInfo } from "../../slices/PersistData/reducer";

const Reports = () => {
  // document.title = "Dashboard | B.N. Rathi";

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const rawHash = location.search;

  useEffect(() => {
    const fetchSSO_token = async () => {
      try {
        const data = await axios.post(
          "/get-token",
          {},
          {
            params: { sso_token: rawHash },
            headers: { Accept: "application/json" },
          }
        );

        if (data?.code === 200) {
          // store login session
          sessionStorage.setItem("authUser", JSON.stringify(data));
          sessionStorage.setItem("welcomeModalShown", "true");
          // redux updates
          dispatch(loginSuccess(data));
          dispatch(addPersistLoginInfo(data));

          //   showToast(data?.message || "Login successful", "success");

          // redirect to dashboard
          navigate("/dashboard");
        } else {
          navigate("/login");
          showToast(data?.message || "Something went wrong", "error");
          dispatch(apiError(data));
        }

        return data;
      } catch (error) {
        dispatch(apiError(error));
        showToast("Error fetching report. Please try again.", "error");
        navigate("/login");
        return error;
      }
    };

    fetchSSO_token();
  }, [rawHash]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            className="centerContent h-100 w-100"
            style={{ minHeight: "80vh" }}
          >
            <CommonLoading />
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Reports;
